/**
 * The automation action types.
 *
 * MIRROR: one row per member in all seven copies — main-consumer
 * `src/lib/workflow/enums.ts` (+ `model.ts` PipeActionSchema), main-backend
 * `org/nikita/workflow/enums/ActionType.java`, website-builder-backend /
 * checkin-app-backend / attendee-app-backend / cron-maintenance
 * `src/lib/workflow/enums.ts`. Pinned here by
 * `src/types/__tests__/actionType.parity.test.ts`.
 *
 * `SEND_SMS` (SMS channel wave, 2026-10): trigger-driven pipes only — never in
 * a SCHEDULED workflow, a company template or the AI wizard's tool schema
 * (`AiWorkflowWizardTools` keeps its own three-member list on purpose). The
 * editor offers it only while the backend's channel switch is on and the
 * event's company has an SMS allowance (`smsChannelEnabled` + `sms.monthlyCap`).
 *
 * `NOTIFY_CONTACT` ("Mail an Kontakt", plan arrival-automation Rev. 4 §1.2 /
 * §1.8): one arrival notice to the event's verified notification contacts —
 * fixed ones or those the guest field "Ankunft melden an" names. Executed only
 * by main-consumer; saved only by an in-person OWNER / ADMIN on an event in
 * `automation` mode, only behind check-in triggers, never in a SCHEDULED
 * workflow, a company template or the AI wizard's tool schema.
 */
export enum ActionType {
  SEND_EMAIL = "SEND_EMAIL",
  HTTP_REQUEST = "HTTP_REQUEST",
  UPDATE_GUEST = "UPDATE_GUEST",
  SEND_SMS = "SEND_SMS",
  NOTIFY_CONTACT = "NOTIFY_CONTACT",
}
